import VLabel from './VLabel';
export { VLabel };
export default VLabel;
//# sourceMappingURL=index.js.map